import React from "react";
import i18n from "i18n";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
import InputProfileCell from "./cells/InputProfileCell";
import InputTitleCell from "./cells/InputTitleCell";
import ForwarderCell from "./cells/ForwarderCell";
import ForwarderStatusCell from "./cells/ForwarderStatusCell";
import ForwarderVersionCell from "./cells/ForwarderVersionCell";
import InputStateCell from "./cells/InputStateCell";
import TrafficLastMinuteCell from "./cells/TrafficLastMinuteCell";
import MessageCountCell from "./cells/MessageCountCell";
import AssociatedStreamsCell from "./cells/AssociatedStreamsCell";
import FailureCountCell from "./cells/FailureCountCell";
import { METRIC_COLUMN_IDS } from "./metricColumns";
const forwarderInputColumnRenderers = ({ inputTypes }) => ({
  attributes: {
    title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(InputTitleCell, { input })
    },
    type: {
      renderCell: (type) => /* @__PURE__ */ React.createElement("span", null, (inputTypes == null ? void 0 : inputTypes[type]) || type)
    },
    input_profile_id: {
      renderCell: (profileId) => /* @__PURE__ */ React.createElement(InputProfileCell, { profileId }),
      staticWidth: COLUMN_WIDTH.reference
    },
    forwarder_title: {
      renderCell: (_title, input) => /* @__PURE__ */ React.createElement(ForwarderCell, { forwarderId: input.forwarder_id, forwarderTitle: input.forwarder_title }),
      staticWidth: COLUMN_WIDTH.reference
    },
    forwarder_status: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(ForwarderStatusCell, { forwarderId: input.forwarder_id }),
      staticWidth: "matchHeader"
    },
    forwarder_version: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(ForwarderVersionCell, { forwarderId: input.forwarder_id }),
      staticWidth: "matchHeader"
    },
    input_state: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(
        InputStateCell,
        {
          forwarderId: input.forwarder_id,
          inputId: input.input_id,
          state: input.input_state,
          stateMessage: input.state_message
        }
      ),
      staticWidth: 110
    },
    traffic_last_minute: {
      renderCell: (_v, input) => /* @__PURE__ */ React.createElement(TrafficLastMinuteCell, { forwarderId: input.forwarder_id, inputId: input.input_id }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    address: {
      renderCell: (_address, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement("span", null, ((_a = input.configuration) == null ? void 0 : _a.bind_address) || i18n.t("common.not_available", { ns: "enterprise_forwarder" }));
      },
      staticWidth: 125
    },
    port: {
      renderCell: (_port, input) => {
        var _a;
        return /* @__PURE__ */ React.createElement("span", null, ((_a = input.configuration) == null ? void 0 : _a.port) || i18n.t("common.not_available", { ns: "enterprise_forwarder" }));
      },
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    [METRIC_COLUMN_IDS.messagesPerStream]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(MessageCountCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    [METRIC_COLUMN_IDS.associatedStreams]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(AssociatedStreamsCell, { input }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    [METRIC_COLUMN_IDS.failureCount]: {
      renderCell: (_value, input) => /* @__PURE__ */ React.createElement(FailureCountCell, { input }),
      staticWidth: "matchHeader"
    }
  }
});
export default forwarderInputColumnRenderers;
